import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useFeatures } from "components/FeatureFlag";
import Modal from "components/Modal";

import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";
import { useIntegrationAction } from "scenes/Onboarding/components/CrmIntegrationStep/hooks";

function SkipIntegrationConfirmationModal({ onClose }) {
  const addUserOnboardingFF = useFeatures("add-user-during-onboarding");
  const { connect, connecting, error } = useIntegrationAction();
  const { fireError } = useContext(ToasterContext);

  const handleOnContinueToMyHub = async () => {
    return connect("HUBLY", "");
  };

  useEffect(() => {
    if (error) {
      fireError(error);
    }
  }, [error, fireError]);

  return (
    <Modal
      isModalOpen
      size="small"
      onClose={onClose}
      closeOnDimmerClick={!connecting}
      data-test="skip-integration-confirmation-modal"
    >
      <Modal.Header onClose={onClose} disabled={connecting}>
        Are you sure you want to skip CRM integration?
      </Modal.Header>
      <Modal.Body>
        <p>
          Feel free to skip the integration now; you can always connect your CRM
          later. Hubly&apos;s customer support will be available to help
          whenever you&apos;re ready. Just click &quot;
          {addUserOnboardingFF?.enable ? "Continue" : "Continue to my Hub"}
          &quot; to proceed.
        </p>
        <p>
          However, if you change your mind and wish to connect now, simply click
          &quot;Connect with my CRM&quot; to return to the previous screen and
          sync with your Redtail or Wealthbox account.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="button"
          basic
          onClick={handleOnContinueToMyHub}
          loading={connecting}
          disabled={connecting}
        >
          {addUserOnboardingFF?.enable ? "Continue" : "Continue to my Hub"}
        </Button>
        <Button primary onClick={onClose} disabled={connecting}>
          Connect with my CRM
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

SkipIntegrationConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

SkipIntegrationConfirmationModal.defaultProps = {};

export default SkipIntegrationConfirmationModal;
